import React from 'react'

function ConditionsForContributorsDE() {
  return (
    <>
      <p className="heading-1">
        Allgemeine Nutzungsbedingungen (ANB) Skeepers Influence
      </p>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">1. Gegenstand</p>
        <p>
          Die vorliegenden Allgemeinen Nutzungsbedingungen (ANB) haben die
          Aufgabe, die Verwendung der Website{' '}
          <a
            href="http://app.im.skeepers.io"
            target="_blank"
            rel="noopener noreferrer"
          >
            http://app.im.skeepers.io
          </a>{' '}
          sowie die allgemeinen Geschäftsbedingungen, zu denen die verschiedenen
          vorgeschlagenen Dienstleitungen auf dieser Website zur Verfügung
          gestellt werden. Das Surfen auf der Website, wie sie im Folgenden
          definiert wird, führt von Rechts wegen zur ausdrücklichen und
          vorbehaltlosen Annahme der vorliegenden ANB durch den Creator.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">2. Definitionen</p>
        <p>
          Die im Folgenden verwandten Bezeichnungen mit einem Großbuchstaben
          haben die ihnen unten zugeteilte Definition:
        </p>
        <div className="definition">
          <p>ANB</p>
          <p>steht für die vorliegenden Allgemeinen Nutzungsbedingungen ;</p>
        </div>
        <div className="definition">
          <p>Creator</p>
          <p>
            steht für eine natürliche oder juristische Person mit einem Konto
            auf der Website ;
          </p>
        </div>
        <div className="definition">
          <p>Dienstleistungen</p>
          <p>steht für die von Skeepers erbrachten Dienstleistungen ;</p>
        </div>
        <div className="definition">
          <p>Influencer</p>
          <p>
            Creator, der ein Produkt kostenlos erhalten hat, damit er
            entsprechende Inhalte in seinem sozialen Netzwerk (z. B. Instagram,
            TikTok, YouTube, Pinterest) veröffentlichen kann ;
          </p>
        </div>
        <div className="definition">
          <p>Inhalt</p>
          <p>
            steht für die Texte, Bilder, Fotografien, Zeichnungen, Avatare und
            im Allgemeinen jede visuelle, textartige, akustische oder graphische
            Veröffentlichung des Creators, die die Produkte darstellen, die im
            Rahmen der Dienste verbreitet werden ;
          </p>
        </div>
        <div className="definition">
          <p>Kunde</p>
          <p>
            steht für die Gesellschaft, den Hersteller oder den Vermarkter des/r
            Produkts/Dienstleistung unter einer Marke, die Gegenstand des
            Inhalts ist ;
          </p>
        </div>
        <div className="definition">
          <p>Produkte</p>
          <p>
            steht für die vom Kunden vermarkteten Produkte und Dienstleistungen
            ;
          </p>
        </div>
        <div className="definition">
          <p>Profil</p>
          <p>
            steht für die dem Creator gewidmete Schnittstelle auf der Website ;
          </p>
        </div>
        <div className="definition">
          <p>Skeepers</p>
          <p>
            steht für die Rechtsform, die im Impressum der Website angegeben
            ist;
          </p>
        </div>
        <div className="definition">
          <p>Soziale Netzwerke</p>
          <p>
            steht für alle bestehenden oder zukünftigen sozialen Netzwerke, die
            Gegenstand der Dienste von Skeepers sein können, wie z. B.: YouTube,
            Instagram, Facebook, Twitter, Twitch, Blogs, TikTok, Pinterest.
          </p>
        </div>
        <div className="definition">
          <p>Tester</p>
          <p>
            Creator, der ein Produkt kostenlos erhalten hat, damit er eine
            Video- (CV) oder Textbewertung (IM) erstellt, die auf der
            E-Commerce-Website des Kunden und/oder seiner Partner veröffentlicht
            wird ;
          </p>
        </div>
        <div className="definition">
          <p>Website</p>
          <p>
            steht für die Internetseite, die zugänglich ist unter der Adresse{' '}
            <a
              href="http://app.im.skeepers.io"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://app.im.skeepers.io
            </a>{' '}
            ;
          </p>
        </div>
        <div className="definition">
          <p>Zugangsdaten</p>
          <p>
            steht für den Creatorname und das Passwort, die dem Creator den
            Zugang zur Website ermöglichen ;
          </p>
        </div>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          3. Beschreibung der Dienstleistungen :
        </p>
        <ul className="paragraph-2">
          <p>Skeepers bietet den Creatorn die folgenden Dienstleistungen:</p>
          <li>
            Zugang zur Website für Creator (einschließlich der Anzeige von
            Statistiken, Austausch und Matching mit Produkten und Kunden)
          </li>
          <li>Zustellung von Produkten und/oder damit verbundenen Vorteilen</li>
        </ul>
        <p>
          Die von Skeepers angebotenen Dienstleistungen werden den Creatorn
          unentgeltlich geboten.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          4. Zugang zu den Dienstleitungen
        </p>
        <p>
          Skeepers gewährleistet ausschließlich den durchgängigen Zugang zur
          Website. Skeepers behält sich das Recht vor zur jederzeitigen
          unangekündigten vollständigen oder teilweisen Bearbeitung, Suspension
          und/oder Löschung der Website und der Angaben, die sie enthält.
          Folglich kann Skeepers für keinerlei entstandenen oder behaupteten
          Schaden verantwortlich gemacht werden, der direkt oder indirekt von
          einem beliebigen Creator erlitten wird in Zusammenhang mit der
          Verbindung, der Konsultation und/oder der Nutzung von Angaben, die von
          der Website geliefert werden.
        </p>
        <p>
          Um Zugang zu den Dienstleistungen zu erhalten, müssen sich die Creator
          auf der Website mit ihren Zugangsdaten zu den unten beschriebenen
          Bedingungen anmelden.
        </p>
        <p>
          Im Allgemeinen kann jeder Verstoß gegen die Bestimmungen der
          vorliegenden ANB unmittelbar und ohne Vorankündigung zur Löschung oder
          Suspension des BeCreatorkontos führen, ungeachtet aller
          Schadensersatz- und Zinsforderungen seitens Skeepers.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">5. Persönliches Skeeper-Konto</p>
        <p className="tc-neutral900 ml-16">1/ Anmeldung</p>
        <p>
          Die Anmeldung auf der Website zwecks Einrichtung eines persönlichen
          Kontos erfolgt über die den Creatorn gewidmete Schnittstelle der
          Website durch Ausfüllen aller als verpflichtend bezeichneten Angaben.
          Der Creator kann auch freiwillige Angaben zu seinen Lieblingsmarken,
          seinen Interessenschwerpunkten, usw. machen, wobei diese Liste nicht
          erschöpfend ist.
        </p>
        <p>
          Skeepers behält sich das Recht vor, alle nicht vollständigen oder
          nicht den Auflagen entsprechenden Anmeldungen abzulehnen.
        </p>
        <p>Der Creator garantiert Skeepers:</p>
        <ul className="paragraph-2">
          <li>
            Der Creator ist mindestens sechzehn (16) Jahre alt. Sollte er in
            seinem Wohnsitzland die Volljährigkeit nicht erreicht haben,
            benötigt er eine elterliche Zustimmung, um ein Konto auf der Website
            einrichten zu können;
          </li>
          <li>
            Der Creator ist weder ehemaliger noch derzeitiger Angestellter von
            Skeepers, noch arbeitet er für eine Medienagentur oder eine
            Werbeagentur, die Partner von Skeepers ist;
          </li>
        </ul>
        <p>
          Als Influencer muss der Creator mindestens ein Konto in einem sozialen
          Netzwerk haben, das öffentlich zugänglich ist und das über eine
          Mindestanzahl von Follower verfügt (diese wird für jedes betroffene
          Soziale Netzwerk auf der Website nach der Anmeldung angegeben) und
          zwar während der gesamten Dauer der Anmeldung auf der Website.
        </p>{' '}
        <p>
          Skeepers behält sich das Recht vor, jederzeit und während der gesamten
          Dauer der Anmeldung zu überprüfen, ob das Konto Soziale Netzwerke des
          Influencers die oben genannten Voraussetzungen vollständig erfüllt.
          Für den Fall, dass das Konto Soziale Netzwerke die oben genannten
          Voraussetzungen nicht mehr erfüllt, behält sich Skeepers das Recht
          vor, das persönliche Konto des Creators auf der Website zu
          deaktivieren und/oder aufzulösen.
        </p>
        <p>
          Der Creator verpflichtet sich, die Anzahl der Ansichten seiner auf
          seinem Konto Soziale Netzwerke veröffentlichten Inhalte, deren
          Ausdrucke und/oder mit ihnen verbundenen Klicks nicht künstlich auf
          automatische oder manuelle Art, selbst oder durch einen Dritten zu
          erhöhen, noch andere Personen aufzufordern, dies zu tun.
        </p>
        <p>
          Der Creator gewährleistet, dass die anlässlich der Einrichtung seines
          Kontos gemachten Angaben zutreffend, ehrlich und persönlicher Natur
          sind. Der Creator verpflichtet sich, regelmäßig seine Angaben auf dem
          laufenden Stand zu halten, um so Skeeper über sein persönliches Profil
          zu unterrichten und die am besten geeigneten, von Skeepers zur
          Verfügung gestellten Dienstleistungen zu nutzen. Skeepers behält sich
          die Möglichkeit vor, inbesondere jedes Konto zu löschen, dessen
          Angaben unrichtig sind, oder deren Adresse, vor allem Postadresse, die
          Zustellung und normale Nutzung der Produkte nicht zulassen. Die
          Anmeldung durch den Creator zieht automatisch die Einrichtung eines
          Kontos und Profils unter dem Nick nach sich, den er in den sozialen
          Netzwerken benutzt, sowie eines Bereichs mit Angaben zum Creator, die
          insbesondere den Kunden im Fall eines Matching zugänglich sind.
        </p>
        <p className="tc-neutral900 ml-16">2/ Das persönliche Konto</p>
        <p>
          Nach der wie oben beschriebenen Anmeldung auf der Website schließt der
          Creator die Einrichtung seines Kontos ab mit der Eingabe der
          Zugangsdaten, die vom Creator auf seinem Konto bearbeitet werden
          können. Das Konto ist zu den selben Bestimmungen zugänglich wie die
          Website. Die Zugangsdaten sind persönlicher Natur und können bei
          Strafe der Suspension oder Löschung des Kontos nicht weiter gegeben
          oder von einem Dritten genutzt werden. Jeder Verdacht auf absichtliche
          oder unabsichtliche Weitergabe der Zugangsdaten und Passwörter schafft
          eine alleinige und persönliche Haftung durch den Creator. In keinem
          Fall kann Skeepers verantwortlich gemacht werden für jegliche
          unerlaubte oder betrügerische Verwendung der Zugangsdaten und
          Passwörter. Das gleiche gilt für die verschiedenen, dem Creator zur
          Verfügung gestellten Tools.
        </p>
        <p>
          Der Creator kann auf seinem Konto auch seine Guthaben, bestellten und
          in Bearbeitung befindlichen Produkte, seine laufenden und
          vorhergehenden Inhalte ansehen.
        </p>
        <p>
          Die Einrichtung eines persönlichen Kontos gibt dem Creator kein
          automatisches Recht auf Nutzung aller Dienstleistungen und
          gewährleistet auch kein "Matching" mit den Produkten. Skeepers behält
          sich die Wahl der begünstigten Tester der Produkte und der Kunde die
          der begünstigten Influencer vor.
        </p>
        <p>
          Der Creator kann von Skeepers jederzeit die Auflösung seines Kontos
          bei Einhaltung einer schriftlichen (E-Mail ist ausreichend)
          Kündigungsfrist von fünfzehn (15) Tagen an Skeepers beantragen.
        </p>
        <p className="tc-neutral900 ml-16">3/ Profil</p>
        <p>
          Die Einrichtung eines Skeepers-Kontos auf der Website führt zur
          Einrichtung eines Profils, mit dem der Creator festgestellt wird und
          das ihn die Dienstleistungen nutzen lässt. Ab der Einrichtung eines
          persönlichen Profils ist der Creator auf der Website durch seinen Nick
          und den Avatar identifiziert, den er auf dem/n sozialen Netzwerk(en)
          nutzt, die der Creator auf der Website angibt. Das Profil enthält auch
          die vorhergehenden, automatisch auf die Website hochgeladenen Inhalte,
          dem der Creator zustimmt.
        </p>
        <p>
          Entsprechend der vom Creator anlässlich seiner Anmeldung gemachten
          Angaben, ist sein Profil geeignet, Produkten zu entsprechen. In einem
          solchen Fall ist ein Matching zwischen dem Creator und den Produkten
          möglich. Dennoch behält sich Skeepers das Recht vor, dieses Matching
          nach eigenen Auswahlkriterien zu beschränken.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          6. Nutzung der Dienstleistungen
        </p>
        <p className="tc-neutral900 ml-16">
          1/ Bestellungen von Produkten und Veröffentlichung von Inhalten
        </p>
        <p>
          Der Creator kann auf seinem Konto die Produkte ansehen, die von den
          Kunden als geeignet angesehen werden, mit seinem Profil ein Match zu
          bilden. Die Angaben zum Preis der Produkte und den zu beachtenden
          Bedingungen bei der Verbreitung des Inhalts, der sich darauf bezieht
          (z. B., ohne dass diese Liste erschöpfend wäre: den Kunden erwähnen,
          einen Hashtag anhängen, usw.) werden auch vom Kunden bei der
          Beschreibung des Produkts genau angegeben.
        </p>
        <p>
          Wenn dem Creator ein Angebot gefällt, kann er das Häkchen "Bestellen"
          wählen, um das Produkt zu erhalten. Nach der Bestätigung der
          Bestellung muss er ein Kästchen ankreuzen, um zu bestätigen, dass er
          die Bedingungen hinsichtlich des Inhalts zur Kenntnis genommen hat,
          den er veröffentlichen muss.
        </p>
        <p>
          Nach Bestätigung der Bestellung erhält der Creator das Produkt
          kostenfrei (entweder direkt vom Kunden oder von Skeepers).
        </p>
        <p>
          Sobald das Produkt empfangen und getestet ist, erstellt der Creator
          einen Inhalt unter Beachtung der vom Kunden in der Produktbeschreibung
          festgelegten Bedingungen, die er angenommen hat.
        </p>
        <p>
          Der Influencer teilt den Link seines Inhalts auf der Website innerhalb
          von einer Stunde nach der Veröffentlichung seines Inhalts auf den
          Sozialen Netzwerken. Der Inhalt ist im Modus "öffentlich" zu
          veröffentlichen und er muss mindestens dreißig (30) Tage ab seiner
          Veröffentlichung auf den Sozialen Netzwerken zugänglich sein, außer im
          Fall eines Sinneswandels hinsichtlich des Produkts, von dem Skeepers
          umgehend per E-Mail zu unterrichten ist.
        </p>
        <p>
          Der Creator kreuzt in Folge ein Kästchen an, um den Vertrag über die
          Abtretung der Rechte anzunehmen (Skeepers Community Agreement).
        </p>
        <p>
          Skeepers behält sich das Recht vor, die Inhalte bei der
          Veröffentlichung auf der Website zu kontrollieren, um ihre
          Übereinstimmung mit den vom Kunden auf der einen Seite und den ANB von
          Skepeers, sowie dem Vertrag über die Abtretung der Rechte auf der
          anderen Seite zu verifizieren.
        </p>
        <p>
          Für den Fall, dass der Inhalt nicht konform sein sollte, kann dieser
          nicht über die Website verbreitet werden. Anderweitig kann Skeepers
          (i) den Creator über diese Nicht-Konformität unterrichten und
          verlangen, dass die für die Konformität des Inhalts notwendigen
          Verbesserungen angebracht werden, damit der Inhalt mit den vom Kunden
          festgelegten Bedingungen, den ANB von Skeepers und dem Vertrag über
          die Abtretung der Rechte konform ist, und/oder (ii) das Konto des
          Creators desaktivieren oder löschen.
        </p>
        <p>
          In Bezug auf schriftliche Testermeinungen verfasst der Tester seinen
          Inhalt auf der Website und nach der Validierung durch Skeepers kopiert
          der Creator den Inhalt innerhalb einer Stunde nach der Validierung auf
          die Website des Kunden.
        </p>

        <p className="tc-neutral900 ml-16">
          2/ Bild des Kunden und der Produkte
        </p>
        <p>
          Als Gegenleistung für die Dienstleistung und insbesondere für die
          Annahme der Produkte ist es die Verpflichtung des Creators, einen
          Inhalt zu veröffentlichen, der die vom Kunden festgelegten Bedingungen
          beachtet, die er seinerseits angenommen hat. Andernfalls behält sich
          Skeepers das Recht vor, den Zugang zu seinen Dienstleistungen zu
          beschränken oder die Zugangsdaten zu löschen.
        </p>
        <p>
          Der BeCreator verpflichtet sich, die Produkte und das Bild der Marke
          des Kunden zu respektieren. Ebenso verpflichtet sich der Creator,
          unter allen Umständen:
        </p>
        <ul className="paragraph-2">
          <li>
            Die erhaltenen Produkte nicht wiederverkaufen oder aus Ihnen auf
            irgendeine Weise während einer Mindestzeit von zwei Jahren nach
            Erhalt oder Zugang zu den Produkten Profit zu schlagen ;
          </li>
          <li>
            Keine Geldbeträge und/oder andere Gegenwerte anzunehmen, um die
            Produkte zu beurteilen (sofern es von Skeepers keine anders
            lautenden Angaben gibt) und die Kunden nur in den Fällen zu
            kontaktieren, die für die Bewertung ihrer Produkte, nach den
            vorliegenden Bestimmungen vorgesehen sind ;
          </li>
          <li>
            Hinsichtlich des Kunden und/oder der Produkte sind im Handeln,
            Kommunizieren, im Ausdruck und in der Redaktion Augenmaß,
            Höflichkeit und Achtung des Anderen zu wahren bei den Kommentaren,
            Beurteilungen und dem Austausch, die er verfassen kann, und die auf
            den sozialen Netzwerken veröffentlicht werden ;
          </li>
          <li>
            Mit Skeepers zusammenarbeiten und ihnen die für eine ordnungsgemäße
            Ausführung der Dienstleistungen notwendigen Angaben zu liefern ;
          </li>
          <li>
            Die vom Kunden auf der Website in der Produktbeschreibung
            vorgesehenen Bedingungen beachten ;
          </li>
        </ul>
        <p>
          Angeben, dass es sich um einen Inhalt in Partnerschaft mit einer Marke
          handelt, dass daher der Inhalt oder die Beziehung zum Kunden unter die
          Kriterien der digitalen Werbung oder kommerziellen Kommunikation
          fällt, wie sie von der ARPP [Behörde zur beruflichen Regulierung der
          Werbung] festgelegt sind.
        </p>
        <p>
          Folglich ist es den Creatorn insbesondere verboten, folgendes zu
          verbreiten, ohne dass die Liste Anspruch auf Vollständigkeit erhebt:
        </p>
        <ul className="paragraph-2">
          <li>
            Pornographische, obszöne, indezente, schockierende oder für die
            Zielgruppe Familien ungeeignete, rufschädigende, beleidigende,
            gewalttätige, rassistische, fremdenfeindliche oder revisionistische
            Inhalte,
          </li>
          <li>gefälschte Inhalte, </li>
          <li>Inhalte, die das Image eines Dritten verletzen,</li>
          <li>
            Unwahre, irreführende Inhalte oder solche, die ungesetzliche,
            betrügerische oder irreführende Aktivitäten fördern, Inhalte, die
            schädlich sind für die Informatiksystem Dritter (wie z. B. Virus,
            Würmer, Trojaner, usw.), und
          </li>
          <li>
            Allgemeiner gesprochen, Inhalte, die geeignet sind, die Rechte
            Dritter anzugreifen, für Dritte schädlich sind, oder die
            Verantwortlichkeit von Skeepers oder des Kunden in irgendeiner Weise
            und welcher Form auch immer in Anspruch nehmen. Zu diesem Zweck
            verpflichtet sich der Creator, Marke und Logo außer der/die Marke(n)
            des/der vom Kunden geschickten Produkts(e) nicht zu erwähnen oder zu
            vertreten, einschließlich auf der Kleidung. Gleicherweise
            verpflichtet sich der Creator, nur frei verfügbare Musikstücke in
            seinem Inhalt zu verwenden. Der Creator verpflichtet sich
            gleichermaßen, keine Kinder außer den eigenen einzuschließen oder zu
            zeigen, ebenso wie Erwachsene, die der Veröffentlichung des Videos
            nicht zugestimmt haben oder sich dieser nicht bewusst sind;
          </li>
        </ul>
        <p>
          Solange der Inhalt oder die Beziehung zum Kunden unter die Kriterien
          der digitalen Werbung oder kommerziellen Kommunikation fällt, wie sie
          von der ARPP [Behörde zur beruflichen Regulierung der Werbung]
          festgelegt sind, oder es der Kunde verlangt, muss der Creator im
          Inneren jedes Inhalts eine klare und unmissverständliche Ankündigung
          einschließen, dass er die bewerteten Produkte gratis von Kunden über
          Skeepers erhalten hat, unter Einschluss:
        </p>
        <ul className="paragraph-2">
          <li>
            Auf YouTube:
            <ul className="paragraph-2">
              <li>
                Zu Beginn des Videos: eines mündlichen hörbaren und
                verständlichen Vortrags des Creators - der vor allem ausreichend
                langsam zu sein hat, mit Worten, die von der Zuhörerschaft
                verstanden werden. Sollte das Video länger als 10 Minuten
                dauern, muss der Creator den Vortrag am Ende des Videos
                wiederholen;
              </li>
              <li>
                Im Abschnitt Über: einen klar und unmissverständlich erklärenden
                Text.
              </li>
            </ul>
          </li>
          <li>
            Auf Instagram:
            <ul className="paragraph-2">
              <li>
                Wenn es sich beim Inhalt um ein Photo handelt: einen klaren und
                unmissverständlichen Text in den 3 ersten Zeilen der
                Beschreibung des Photos.
              </li>
              <li>
                Wenn es sich beim Inhalt um eine Story handelt: einen klaren und
                unmissverständlichen Hashtag in jeder verbreiteten Story.
              </li>
            </ul>
          </li>
          <li>
            Auf der Internetseite des Kunden: einen klaren und
            unmissverständlichen Text, der in den ersten drei Zeilen des
            Kommentars des Creators zum Produkt des Kunden verfügbar ist.
          </li>
          <li>
            Der Inhalt muss die ehrliche Meinung und Erfahrung des Creators
            wiedergeben auf Grundlage der tatsächlichen Nutzung des Produkts.
            Der Creator verpflichtet sich, Skeepers unmittelbar davon zu
            unterrichten, sollte sich seine Meinung zum genannten Produkt ändern
            und den entsprechenden Inhalt sofort entfernen.
          </li>
          <li>
            Der Creator verpflichtet sich, keine wissenschaftlichen Behauptungen
            über das Produkt oder solche über seine Leistung aufzustellen (wie
            z. B. "es verringert die Falten!" oder "es hält mich den ganzen Tag
            hydratisiert! "). Der Creator muss sich darauf konzentrieren, was er
            aus seinem persönlichen Blickwinkel am Produkt schätzt oder eben
            auch nicht.
          </li>
        </ul>
        <p>
          Jeder Verstoß gegen die Bestimmungen des vorliegenden Artikels und im
          Allgemeinen gegen die vorliegenden ANB kann unmittelbar und ohne
          Vorankündigung zur Löschung oder Suspension des BeCreatorkontos
          führen, ungeachtet aller Schadensersatz- und Zinsforderungen seitens
          Skeepers.
        </p>
        <p>
          Außerdem können Skeepers und/oder der Kunde gleichermaßen vom Creator
          verlangen, den betroffenen Inhalt im Fall der Nichtbeachtung der oben
          festgelegten Regeln und Prinzipien zu entfernen, was jener
          unverzüglich nach Empfang der Aufforderung dazu unternimmt.
        </p>
        <p>
          Jedes erhaltene Produkt ist zur ausschließlich persönlichen Verwendung
          des Creators. Dem Creator ist der Verkauf untersagt. Der Creator kann
          das Produkt einem Dritten nur schenken oder anbieten, nachdem er es
          getestet und einen mit den vorliegenden ANB konformen Inhalt
          veröffentlicht hat.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          7. Abtretung der Nutzungsrechte am Inhalt und Genehmigung von
          Bildrechten
        </p>
        <p>
          Die Veröffentlichung des Inhalts auf der Website des Creators führt
          gleichzeitig zum Abschluss eines Vertrags über Abtretung der
          Nutzungsrechte zwischen Skeepers und dem Creator über den vom Creator
          erstellten Inhalt (Skeepers Community Agreement) sowie zur Abtretung
          seiner Bildrechte, auf die unter dem folgenden Link zugegriffen werden
          kann:{' '}
          <a
            href="https://app.im.skeepers.io/community-agreement"
            target="_blank"
            rel="noopener noreferrer"
          >
            app.im.skeepers.io/community-agreement
          </a>
        </p>
        <p>
          Im Falle der Weigerung des Creators, den genannten Vertrag zur
          Abtretung der Rechte zu unterzeichnen, kann dieser seinen Inhalt nicht
          veröffentlichen und muss daher das Produkt an den Versender
          zurückschicken.
        </p>
        <p>
          Die vom Creator verfasste Kundenbewertung ist vergleichbar mit einem
          Testimonial, bezieht sich immer auf ein erlebtes Verbrauchserlebnis
          und ist eine reine Information für zukünftige Tester. Somit können
          Skeepers und seine Partner den Inhalt von Kundenbewertungen weltweit
          und in allen Medien und auf jedem Medium und jeglichem Träger frei
          verwenden, vervielfältigen, veröffentlichen, zur Verfügung stellen und
          übersetzen.
        </p>
        <p>
          Der Creator sieht am Tag der Annahme der vorliegenden ANB keinen
          Widerspruch oder Vorbehalt zu den Bestimmungen dieses Artikels. Er
          erkennt ausdrücklich an, dass er, sollte er nicht zur Unterzeichnung
          des Vertrags über die Abtretung der Rechte bereit sein, er sich der
          Bestellung eines Produkts auf der Website enthält, da die Abwesenheit
          der Abtretung des Rechts am geistigen Eigentum und dem Bildrecht, die
          mit dem Inhalt verbunden sind, eine reine Zeitverschwendung für
          Skeepers darstellen würden.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">8. Herunterladen von Inhalten</p>
        <p>
          Der Kunde kann den betreffenden Inhalt auf nicht ausschließlicher
          Grundlage zur Vervielfältigung, Repräsentation und Unter-Vergabe
          herunterladen und ihn insbesondere auf jedem Träger mit einschließen.
          Der Kunde ist gleichermaßen von der Genehmigung zur Nutzung der Bilder
          von Personen begünstigt, die in diesen Inhalten dargestellt und vom
          Kunden auf Verlangen identifiziert werden. Die vorgenannten Recht
          werden vom Creator an Skeepers über den Vertrag zur Abtretung der
          vorgenannten Rechte abgetreten. Skeepers tritt die genannten Rechte an
          den Kunden in einer nicht-ausschließlichen Lizenz ab.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">9. Garantie</p>
        <p>
          Der Creator erklärt und gewährleistet, dass er die Inhalte
          (einschließlich der Rechte, die mit ihnen verbunden sind und
          einschließlich der Bildrechte) in voller Eigentümerschaft hält
          und/oder dass der Creator über alle notwendigen Rechte und
          Genehmigungen zur Nutzung und Verbreitung des Inhalts verfügt und dass
          es keine Vereinbarung oder Recht gibt, die/das ein Hindernis für die
          vorliegende Gewährleistung an der Abtretung oder der
          Nutzungsgenehmigung des Bildes und des Inhalts darstellen könnte.
        </p>
        <p>
          Im dem Fall der Anwendbarkeit des Gesetzes Nr. 2020-1266 vom 19.
          Oktober 2020 zur Einschränkung der gewerblichen Nutzung der Bilder von
          Kindern unter 16 Jahren auf den Online-Plattformen und seiner
          nachfolgenden Verordnungen zur Anwendung, sind die gesetzlichen
          Vertreter der minderjährigen Kinder gehalten, bei der zuständigen
          Verwaltungsbehörde die notwendigen Bewilligungen zu beantragen.
          Skeepers entbindet sich von jeglicher Haftung für den Fall, dass der
          oder die gesetzlichen Vertreter die besagte Genehmigung nicht
          erhalten. Der Kunde kann jederzeit verlangen, die den gesetzlichen
          Vertretern erteilte Vereinbarung zu überprüfen, die diese dann auf
          erste Anfrage mitteilen sollten. In diesem Zusammenhang werden die zu
          beachtenden Formalitäten auf der offiziellen Website der französischen
          Verwaltung ausführlich beschrieben.
        </p>
        <p>
          Der Creator gewährleistet gleichermaßen, dass diese Inhalte die
          öffentliche Ordnung, die guten Sitten oder die Rechte Dritter nicht
          beeinträchtigen, keine gesetzlichen oder verwaltungsrechtlichen
          Bestimmungen verletzen und im Allgemeinen nicht dazu geeignet sind,
          die zivil- oder strafrechtliche Verantwortlichkeit von Skeepers oder
          des Kunden aufs Spiel zu setzen.
        </p>
        <p>
          In Folge des Vorhergehenden gewährleistet der Creator Skeepers und den
          Kunden gegen jegliche Klage, Forderung, Geltendmachung, Eviktion
          seitens jedermann, der die Nicht-Beachtung der anwendbaren
          Bestimmungen, ein Immaterialgüterrecht geltend macht, das die Inhalte
          beeinträchtigte oder beeinträchtigt hätte, eines unlauteren und/oder
          schädlichen Wettbewerbsverhaltens, eines Angriffs auf die öffentliche
          Ordnung, die guten Sitten oder die Rechte Dritter und insbesondere
          tendenziell ihre Nutzung verbietet oder beschränkt und stellt folglich
          Skeepers und den Kunden von allen Folgen frei, die aus einem Verstoß
          gegen die vorliegende Gewährleistung folgen könnten (insbesondere alle
          Verluste, Schäden und Zinsen, einschließlich Ausgaben und Gebühren,
          insbesondere Gerichtsgebühren und Anwaltshonorare).
        </p>
        <p>
          Skeepers überwacht die Website nicht, behält sich aber das Recht vor,
          jeglichen Inhalt zu entfernen, der gegen die ANB verstößt oder das
          anwendbare Gesetze nicht beachtet, einschließlich derer, die ein
          Immaterialgüterrecht verletzen, sobald Skeepers von der
          Rechtswidrigkeit des genannten Inhalts Kenntnis hat. Zu diesem Zweck
          ist jeder Creator gehalten, Skeepers zu kontaktieren, wenn er davon
          ausgeht, dass ein Inhalt eines seiner Rechte und/oder das anwendbare
          Gesetz verletzt und zwar unter Einhaltung der gesetzlich
          vorgeschriebenen Formalitäten für die Aufforderung zur Entfernung von
          rechtswidrigem Inhalt.
        </p>
        <p>
          Nach Erhalt eines nach geltendem Recht gültigen Entfernungsantrags
          wird Skeepers den Inhalt, auf den sich der Antrag bezieht, umgehend
          von der Website entfernen.
        </p>
        <p>
          Der Creator muss die Risiken, die mit der Nutzung jeglicher Inhalte
          verbunden sind, einschätzen und tragen, insbesondere in Bezug auf die
          Richtigkeit, Vollständigkeit oder Nützlichkeit solcher Inhalte.
        </p>
        <p>
          Der Creator nimmt zur Kenntnis und erkennt an, dass alle Fragen,
          Kommentare, Vorschläge, Ideen, Eindrücke oder weitere Angaben
          hinsichtlich der Dienstleistungen (im Folgenden "Vorschläge"), die der
          Creator Skeepers zur Verfügung stellt, nicht vertraulich sind und
          Skeepers das Recht hat, diese Vorschläge ohne Einschränkung zu nutzen
          und zu verbreiten zu jedem Zweck, sei er kommerziell oder anderer Art,
          ohne dass dem Creator irgendeine Anerkennung oder gleich welche
          Vergütung zusteht.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">10. Informatik und Freiheiten</p>
        <p>
          Im Rahmen seiner Aktivitäten und der Bereitstellung von
          Dienstleistungen verarbeitet Skeepers personenbezogene Daten der
          Creator nach den durch die anwendbare Verordnung festgelegten
          Bedingungen. Die verschiedenen durchgeführten Verarbeitungen, sowie
          die Rechte der Creator sind in den Datenschutzrichtlinien von Skeepers
          beschrieben, zu finden auf der Website unter dem folgenden:{' '}
          <a
            href="https://app.im.skeepers.io/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            app.im.skeepers.io/privacy
          </a>
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">11. Cookies</p>
        <p>
          Beim Besuch der Website werden möglicherweise Cookies auf dem
          Computer, dem Handy oder dem Tablet des Creators abgelegt. Die
          Verwendung bestimmter Cookies erfordert die vorherige Zustimmung des
          Creators. Informationen zu den auf dieser Website verwendeten Cookies
          finden Creator hier:{' '}
          <a
            href="https://app.im.skeepers.io/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            app.im.skeepers.io/privacy
          </a>
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          12. Geistiges Eigentum an den Elementen der Website
        </p>
        <p>
          Die Gesamtheit der Veröffentlichungen auf der Website, wi z. B.
          Geräusche, Bilder, Fotografien, Videos, Schriftstücke, Animationen,
          Programme, Grafiken, Hilfsprogramme, Datenbanken, Software und andere
          unterliegende Technologien ist durch das Gesetzbuch des geistigen
          Eigentums geschützt, gehört Skeepers oder ist Gegenstand einer
          Skeepers erteilten Lizenz. Alle Kennzeichen auf der Website,
          insbesondere die Firmennamen, Marken und Logotypen sind Marken, die
          von Skeepers oder Dritten oder Partnern, insbesondere den Kunden,
          gehalten werden, deren Angebote auf der Website vorgestellt werden.
          Jegliche vollständige oder teilweise Abbildung, Bearbeitung oder
          Verwendung dieser Marken, Illustrationen, Bilder und Logotypen aus
          welchem Grund und auf welchem Träger auch immer ohne vorherige und
          ausdrückliche Zustimmung des Rechtsinhabers ist strengstens verboten
          und stellt eine Nachahmung dar, die vom Gesetzbuch des geistigen
          Eigentums mit Strafe belegt wird. Der Creator verpflichtet sich, die
          Website und ihren Inhalt nur in einem rein privaten Rahmen zu nutzen.
          Eine Nutzung für kommerzielle Zwecke ist strengstens untersagt. Der
          Creator holt die vorherige Genehmigung von Skeepers für jede
          Vervielfältigung, Veröffentlichung, Kopie der verschiedenen Inhalte
          ein.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">13. Verweise und Links </p>
        <p>
          Dem Creator werden Hypertext-Links zur Verfügung gestellt, die auf
          Partnerseiten oder Seiten Dritter verweisen. Da Skeepers diese Seiten
          nicht kontrollieren kann, ist Skeepers nicht verantwortlich für die
          Informationen, die auf diesen Seiten enthalten sind. Skeepers haftet
          insbesondere nicht für Änderungen oder Aktualisierungen dieser
          Websites oder für jegliche Fehlfunktionen dieser Websites. Skepeers
          kann in keinem Fall verantwortlich gemacht werden für direkte oder
          indirekte Schäden aus der Navigation oder dem Herunterladen von auf
          der Internetseite veröffentlichten Hyperlinks.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">14. Verantwortlichkeit</p>
        <p>
          Die Nutzung der Website setzt die Kenntnis und Anerkennung der
          Charakteristiken und Grenzen des Internets und der damit verbundenen
          Technologien durch den BeCreator voraus. Skeepers kann für keinerlei
          Schäden verantwortlich gemacht werden, die aus einer Verbindung mit
          der Website entstehen, die der Creator unter seiner ausschließlichen
          Verantwortung vornimmt. In dieser Eigenschaft lehnt Skeepers jegliche
          Verantwortung ab, insbesondere im Fall eines falschen Gebrauchs oder
          eines Vorfalls im Zusammenhang mit der Nutzung des Geräts zur
          Verbindung mit der Website, des Zugangs zum Internet, der Wartung oder
          durch Fehlfunktionen der Server, der Telefonleitung oder anderer
          technischer Verbindungen, dem Versand von Formularen an eine falsche
          oder unvollständige Adresse, jeglichen Informatik-Fehlern oder auf der
          Website festgestellten Mängeln. Darüber hinaus bemüht sich Skeepers,
          auf der Website genaue und aktuelle Informationen zur Verfügung zu
          stellen. Skeepers haftet jedoch in keiner Weise für Ungenauigkeiten
          oder Auslassungen auf seiner Website.
        </p>
        <p>
          Skeepers ist nur verantwortlich für direkte Schäden aus der Nutzung
          der Website und in jedem Fall ist seine Verantwortlichkeit, da der
          Zugang zur Dienstleistung gratis ist, auf den Betrag von 100 €
          begrenzt. Folglich lehnt Skeepers jegliche Verantwortung ab und kann
          nicht verantwortlich gemacht werden für gleich welchen indirekten
          Schaden aus außerhalb seiner Website liegenden Gründen, wie z. B.,
          ohne Anspruch auf Vollständigkeit der Liste: aus der Nutzung oder dem
          Empfang eines vom Creator erhaltenen Produkts, aus oder in Verbindung
          mit einem vom Creator erstellten Inhalt, aus oder in Verbindung mit
          einer Zuordnung zwischen Kunde und Creator, usw.
        </p>
        <p>
          Skeepers erinnert die Creator daran, dass sie möglicherweise
          steuerrechtlichen (Mehrwertsteuer, Steuern etc.) und sozialen (URSSAF
          etc.) Verpflichtungen in Bezug auf ihre Aktivitäten unterliegen, für
          die sie die volle Verantwortung tragen. Die umzusetzenden
          Vorgehensweisen in Übereinstimmung mit den gesetzlichen und
          verordnungsrechtlichen Vorschriften in der Sache, die von
          verschiedenen Kriterien je nach besonderem Fall des Creators abhängig
          sind.
        </p>
        <p>
          Außer den im Vorliegenden vorgesehenen Garantien gewährleistet der
          Creator die Gesellschaft Skeepers gegen alle Strafanzeigen,
          Beschwerden, Klagen und/oder jegliche Schadenersatzansprüche, die
          Skeepers entstehen könnten aus dem Sachverhalt einer Verletzung
          irgendeiner seiner Verpflichtungen oder Gewährleistungen durch den
          Creator im Einklang mit den vorliegenden allgemeinen Bedingungen. Er
          verpflichtet sich, Skeepers von jeder Benachteiligung freizuhalten,
          die sie betreffen könnte und ihr alle Unkosten, Gebühren und/oder
          Strafen zu erstatten, die ihr aus diesem Tatbestand entstehen könnten.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          15. Annahme der Bedingungen zur Nutzung der Sozialen Netzwerke
        </p>
        <p>
          Skeepers verwendet die API von YouTube insbesondere zur
          Authentifizierung und Verbindung des YouTube-Kanals des Creators mit
          seinem Profil auf der Website. Folglich nimmt der Creator durch die
          Nutzung der Website ausdrücklich die Bedingungen zur Nutzung von
          YouTube an, die unter der folgenden URL zu finden sind:{' '}
          <a
            href="https://www.youtube.com/t/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.youtube.com/t/terms
          </a>
        </p>
        <p>
          In der gleichen Weise verpflichtet sich der Creator, die
          Nutzungsbedingungen jedes Sozialen Netzwerks, das er zur
          Veröffentlichung seiner Inhalte nutzt, zur Kenntnis zunehmen und
          beachten.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">16. Sonstige Bestimmungen</p>
        <p>
          Skeepers behält sich das Recht vor, die vorliegenden ANB jederzeit zu
          ändern. Eine Nachricht in Form eines Pop-ups auf der Website
          informiert die Creator über die Aktualisierung der AGB. Dem Creator
          wird empfohlen, die AGB regelmäßig zu lesen.
        </p>
        <p>
          Die Ungültigkeit einer Bestimmung dieser AGB oder eines Teils davon
          hat nicht die Ungültigkeit der übrigen Bestimmungen zur Folge.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">17. Beitritt</p>
        <p>
          Die Annahme der vorliegenden allgemeinen Bedingungen ist
          gekennzeichnet durch ein anzukreuzendes Kästchen im Anmeldeformular,
          das dem Creator vorgelegt wird anlässlich seiner Anmeldung auf der
          Website durch einen Internetlink zu den ANB. Die Annahme geschieht
          ohne Vorhalt. Desweiteren stehen die ANB jederzeit auf der Website zur
          Verfügung.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">18. Anwendbares Recht</p>
        <p>
          Die Website und die ANB unterliegen dem französischen Recht. Alle
          Streitsachen aus der Auslegung oder Ausführung der vorliegenden ANB
          unterliegen der Zuständigkeit der zuständigen Gerichtsbarkeit in
          Marseille.
        </p>
      </div>
    </>
  )
}

export default ConditionsForContributorsDE
